import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { QueryKey } from '../../domain/enums/query-key'
import { GetInvoices } from '../../usecases/get-invoices'

export const useGetInvoices = (offersIds: string[]) => {
  const container = useContainer()

  return useQuery([QueryKey.getInvoices], () => new GetInvoices(container.get(HttpClient)).execute(offersIds), {
    retry: 3,
  })
}
